var React = require('react');

function Box (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M382.369 134.862L279.279 382.369L31.7719 279.279L134.862 31.7721L382.369 134.862Z","fill":"#D94F46"}));
}

Box.defaultProps = {"width":"0","height":"0","viewBox":"0 0 415 415","fill":"none","className":"shape","id":"box"};

module.exports = Box;

Box.default = Box;
